// Prospect sources — stored as ENGLISH codes (i18n keys); the displayed name
// follows the user's language via t(). The three web-origin sources are set
// automatically by the incoming-lead flows and can never be changed.
export const AUTO_SOURCES = ["SEO PO", "Adwords Local", "Adwords General"];

export const PROSPECT_SOURCES = [
  ...AUTO_SOURCES,
  "Trade show",
  "Store visit",
  "Phone call",
  "Word of mouth",
];

export const prospectSourceOptions = (t) =>
  PROSPECT_SOURCES.map((source) => ({ name: t(`${source}`), code: source }));
